import "../style/user-qr.scss"

import { NativeEventBridge } from "@ng-mw/shared-react-components"
import AppGlobalSettings from "@app/AppGlobalSettings"
import MenyNativeEvent from "@app/events/MenyNativeEvent"
import { hideAgreementDeactivationPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import { useLoyaltyClubStatus } from "@modules/loyalty-club/helpers"
import { deactivateAgreementAndLogOut } from "@modules/user/helpers/deactivateAgreementAndLogOut"
import { logOut } from "@modules/user/store/actions/user"
import { consentsActions, consentsCreator } from "@ng-mw/shared-react-components/consents"
import ItemType from "@ng-mw/shared-react-components/src/modules/consents/const/ItemType"
import React from "react"
import { useDispatch, useSelector, useStore } from "react-redux"

// Components
import Popup, { PopupButtons, PopupContent, PopupText } from "@modules/popup/Popup"
import Alert from "@ng-mw/reol/components/Alert"
import Button from "@ng-mw/reol/components/Button"

export const AgreementDeactivationPopup = () => {
    const dispatch = useDispatch<any>()
    const store = useStore<RootState>()
    const isOpen = useSelector((state: RootState) => state.app.agreementDeactivationPopup.visible)
    const { error } = useSelector((state: RootState) => state.consents)
    const { isLoyaltyClubMember, loyaltyClubAgreement, isConsentsInitialized } =
        useLoyaltyClubStatus()
    const agreementToDeactivate =
        loyaltyClubAgreement ||
        ({
            id: AppGlobalSettings.loyaltyClubAgreementId,
            chainId: AppGlobalSettings.chainId,
            itemType: ItemType.Agreement,
        } as any)
    const isDeactivateButtonDisabled = !isConsentsInitialized || !isLoyaltyClubMember

    const handleClose = () => {
        dispatch(consentsCreator.updateStatusError(null))
        dispatch(hideAgreementDeactivationPopup())
    }

    const handleDeactivate = async () => {
        if (isDeactivateButtonDisabled || loyaltyClubAgreement?.updating) {
            return
        }

        await deactivateAgreementAndLogOut({
            agreementToDeactivate,
            dispatch,
            getState: store.getState,
            updateStatusError: consentsCreator.updateStatusError,
            updateAgreementStatus: consentsActions.updateAgreementStatus,
            forceLogOut: () => NativeEventBridge.broadcastNative(MenyNativeEvent.ForceLogOut),
            logOut,
            hideAgreementDeactivationPopup,
        })
    }

    return (
        <Popup
            onClose={handleClose}
            isOpen={isOpen}
            title="Bekreft deaktivering av MENY MER"
        >
            <PopupContent isSimple>
                <PopupText>
                    Deaktiverer du MENY MER vil du ikke lenger få mer Trumf-bonus på utvalgte
                    produkter, personlige kuponger og andre fordeler. Du vil også bli logget ut av
                    appen.
                </PopupText>
            </PopupContent>
            <PopupButtons isSimple>
                <Alert
                    show={!!error}
                    error={error}
                />
                <Button
                    text="Deaktiver og logg ut"
                    onClick={handleDeactivate}
                    isDisabled={isDeactivateButtonDisabled || loyaltyClubAgreement?.updating}
                    isLoading={loyaltyClubAgreement?.updating}
                />
                <Button
                    text="Avbryt"
                    isCancel
                    onClick={handleClose}
                />
            </PopupButtons>
        </Popup>
    )
}

export default AgreementDeactivationPopup
